import { defineComponent, reactive, ref, watch, toRefs, onMounted } from "vue";
import pieAll from './pieAll';
import { weChatrequest } from '@/utils/request';
export default defineComponent({
  components: {
    pieAll
  },
  name: '',
  props: {
    cellData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  setup(props) {
    const state = reactive({
      chartData: [],
      pData: {
        '阀门告警': 0,
        '压力告警': 0,
        '信号告警': 0,
        '其它告警': 0
      }
    });
    const methods = reactive({
      getChart: () => {
        // 告警分类统计
        weChatrequest({
          url: "/api/v1/actuator/alarm/listAlarmType",
          method: "get"
        }).then(res => {
          if (res.code == 0) {
            state.chartData = [];
            state.pData = res.data;
            for (const key in res.data) {
              state.chartData.push({
                'name': key,
                'value': res.data[key]
              });
            }
          } else {
            state.chartData = [];
          }
        });
      }
    });
    onMounted(() => {
      methods.getChart();
    });
    return {
      ...toRefs(state),
      ...toRefs(methods)
    };
  }
});